import { UseFiltersReturnType } from './useFilters';

/**
 * A function that is called when the user clicks one of the "Apply" buttons in DataViewFilters.
 *
 * A return value of `{ preventDismiss: true }` can be used to prevent the DataViewFilters drawer or a FilterDropdown from closing, such as when some filters have invalid values.
 */
export type OnApplyFilters = () => Promise<{ preventDismiss?: boolean } | void> | { preventDismiss?: boolean } | void;

export enum DrawerStyle {
  /** Displays all groups and their fields without the need for navigating submenus. */
  Cascade = 'cascade',
  /** Displays only group names or fields; navigation between the group names and a submenu of fields is required. */
  Nested = 'nested',
}

export type DrawerStyles = `${DrawerStyle}`;

export interface DataViewFiltersUtilsInjection {
  useFiltersInstance?: UseFiltersReturnType;
  drawerStyle?: DrawerStyles;
}
